import { defineManifest } from "@crialume/sdk";
import { HeartbeatIcon, HouseIcon } from "@crialume/ui/icons";

/**
 * Único arquivo do módulo que entra no bundle inicial — mantenha-o leve:
 * nada de imports de páginas aqui, só o `loader` dinâmico.
 */
export default defineManifest({
  id: "home",
  version: "0.1.0",
  meta: {
    name: "Início",
    description: "Visão geral da conta",
    icon: HouseIcon,
    category: "core",
    order: 0,
  },
  requirements: {
    permissions: ["home.view"],
  },
  nav: [
    { label: "Visão geral", path: "", icon: HouseIcon },
    { label: "Status da API", path: "status", icon: HeartbeatIcon },
  ],
  loader: () => import("./module"),
});
